import { Component, ComponentType } from "react";
import Submit, { SubmitProps } from "./Submit";
import Input, { InputProps } from "./Input";

interface LoginFormProps {
    children: React.ReactNode
}

class LoginForm extends Component<LoginFormProps> {
    static Input: ComponentType<InputProps> = Input;
    static Submit: ComponentType<SubmitProps> = Submit;

    render() {
        return (
                <form>
                    {this.props.children}
                </form>
        )
    }
}

export default LoginForm